import StripeGenerator from './StripeGenerator';

export default StripeGenerator;
